export default __webpack_public_path__ + "static/media/sso_google.46cdafcc.svg";